import styled, { css } from "styled-components";
export const BaseGridContainer = styled.section `
	min-width: 1200px;
	margin: 0 auto;
	position: relative;

	${({ gridWidth }) => {
    if (typeof gridWidth === "number" && gridWidth) {
        return css `
				width: ${gridWidth}px;
			`;
    }
    return css `
			width: ${gridWidth || "1200px"};
		`;
}}
	${({ gridHeight }) => {
    if (typeof gridHeight === "number" && gridHeight) {
        return css `
				height: ${gridHeight}px;
			`;
    }
    return css `
			height: ${gridHeight || "auto"};
		`;
}}
`;
